<template>
  <div class="box-container" :class="[space, color]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Box',
  props: {
    space: {
      type: String,
      default: 'small',
    },
    color: {
      type: String,
      default: 'bg-white',
    }
  }
}
</script>

<style lang="scss" scoped>
.box-container {
  box-shadow: 0px 6px 54px 0px #0000000d;

  border-radius: 8px;

  &.small {
    padding: 1rem;
  }

  &.medium {
    padding: 2rem;
  }

  &.bg-white {
    background: #FFF;
  }

  &.bg-gray {
    background: #F5F6FA;
  }
}
</style>